const INVITATION_HEX_TOKEN_REGEX = /\b[a-f0-9]{64}\b/i;
export const INVITATION_TOKEN_QUERY_PARAM = "inviteToken";

export function extractInvitationToken(input: string): string | null {
  const trimmedInput = input.trim();

  if (!trimmedInput) {
    return null;
  }

  try {
    const parsedUrl = new URL(trimmedInput);
    const queryToken =
      parsedUrl.searchParams.get("token") ??
      parsedUrl.searchParams.get(INVITATION_TOKEN_QUERY_PARAM);

    if (queryToken && INVITATION_HEX_TOKEN_REGEX.test(queryToken)) {
      return queryToken;
    }

    const pathToken = INVITATION_HEX_TOKEN_REGEX.exec(parsedUrl.pathname)?.[0];
    return pathToken ?? null;
  } catch {
    const directToken = INVITATION_HEX_TOKEN_REGEX.exec(trimmedInput)?.[0];
    return directToken ?? null;
  }
}
